import { render } from "./BsListPage.vue?vue&type=template&id=29532356&scoped=true"
import script from "./BsListPage.vue?vue&type=script&lang=js"
export * from "./BsListPage.vue?vue&type=script&lang=js"

import "./BsListPage.vue?vue&type=style&index=0&id=29532356&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29532356"]])

export default __exports__